import React, { useEffect, useState } from "react";
import {
  collection,
  onSnapshot,
  query,
  where,
} from "firebase/firestore";

import { db } from "../firebase";
import VolatilityHeader from "./VolatilityHeader";
import BottomNavVolatility from "./BottomNavVolatility";
import "./VolatilityClosed.css";

const getDate = (value) => {
  if (!value) return "—";

  if (typeof value.toDate === "function") {
    return value.toDate().toLocaleString();
  }

  if (typeof value.seconds === "number") {
    return new Date(value.seconds * 1000).toLocaleString();
  }

  const date = new Date(value);
  return Number.isNaN(date.getTime())
    ? "—"
    : date.toLocaleString();
};

const Close = () => {
  const [trades, setTrades] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const username = (
      localStorage.getItem("username") || ""
    ).trim();

    if (!username) {
      setTrades([]);
      setLoading(false);
      setError("Username haijapatikana. Ingia tena.");
      return undefined;
    }

    const q = query(
      collection(db, "volatilityorder"),
      where("username", "==", username)
    );

    const unsubscribe = onSnapshot(
      q,
      (snapshot) => {
        const rows = snapshot.docs
          .map((item) => ({
            id: item.id,
            ...item.data(),
          }))
          .filter((trade) =>
            ["WON", "LOST", "CLOSED", "COMPLETED"].includes(
              String(trade.status || "").toUpperCase()
            )
          )
          .sort((a, b) => {
            const dateA =
              a.closedAt?.toMillis?.() ||
              a.updatedAt?.toMillis?.() ||
              a.createdAt?.toMillis?.() ||
              a.closedAt?.seconds * 1000 ||
              a.updatedAt?.seconds * 1000 ||
              a.createdAt?.seconds * 1000 ||
              0;

            const dateB =
              b.closedAt?.toMillis?.() ||
              b.updatedAt?.toMillis?.() ||
              b.createdAt?.toMillis?.() ||
              b.closedAt?.seconds * 1000 ||
              b.updatedAt?.seconds * 1000 ||
              b.createdAt?.seconds * 1000 ||
              0;

            return dateB - dateA;
          });

        setTrades(rows);
        setLoading(false);
        setError("");
      },
      (err) => {
        console.error("Closed trades error:", err);
        setError("Imeshindikana kupakia closed trades.");
        setLoading(false);
      }
    );

    return unsubscribe;
  }, []);

  return (
    <div className="trade-records-page">
      <VolatilityHeader />

      <main className="trade-records-container">
        <div className="trade-records-heading">
          <div>
            <h1>Closed Trades</h1>
            <p>Historia ya trades zilizofungwa</p>
          </div>

          <span className="record-count">
            {trades.length} trades
          </span>
        </div>

        {loading ? (
          <div className="record-message">Inapakia records...</div>
        ) : error ? (
          <div className="record-message record-error">{error}</div>
        ) : trades.length === 0 ? (
          <div className="record-empty">
            <h2>Hakuna closed trades</h2>
            <p>Trades zako zilizofungwa zitaonekana hapa.</p>
          </div>
        ) : (
          <div className="record-list">
            {trades.map((trade) => {
              const status = String(trade.status || "CLOSED").toUpperCase();
              const result = Number(trade.result ?? trade.profit ?? 0);

              return (
                <article
                  className={`record-card ${
                    status === "WON" ? "record-won" : "record-lost"
                  }`}
                  key={trade.id}
                >
                  <div className="record-card-top">
                    <div>
                      <h2>
                        {trade.tradeType || trade.type ||
                          trade.contractType || "Trade"}
                      </h2>
                      <p>
                        {trade.marketName || trade.marketSymbol || "Volatility"}
                      </p>
                    </div>

                    <span
                      className={`record-status ${
                        status === "WON" ? "status-won" : "status-lost"
                      }`}
                    >
                      {status}
                    </span>
                  </div>

                  <div className="record-grid">
                    <div>
                      <span>Trade ID</span>
                      <strong>{trade.localTradeId || trade.tradeId || trade.id}</strong>
                    </div>

                    <div>
                      <span>Stake</span>
                      <strong>
                        {Number(trade.stake ?? trade.amount ?? 0).toFixed(2)}
                      </strong>
                    </div>

                    <div>
                      <span>Entry Price</span>
                      <strong>{trade.entryPrice ?? "—"}</strong>
                    </div>

                    <div>
                      <span>Exit Price</span>
                      <strong>{trade.exitPrice ?? "—"}</strong>
                    </div>

                    <div>
                      <span>Digits</span>
                      <strong>
                        {trade.entryDigit ?? "—"} → {trade.exitDigit ?? "—"}
                      </strong>
                    </div>

                    <div>
                      <span>Result</span>
                      <strong className={result >= 0 ? "result-positive" : "result-negative"}>
                        {result >= 0 ? "+" : ""}
                        {result.toFixed(2)}
                      </strong>
                    </div>

                    <div>
                      <span>Closed At</span>
                      <strong>{getDate(trade.closedAt || trade.updatedAt || trade.createdAt)}</strong>
                    </div>
                  </div>
                </article>
              );
            })}
          </div>
        )}
      </main>

      <BottomNavVolatility />
    </div>
  );
};

export default Close;
